import { observer } from 'mobx-react-lite';
import React from 'react';
import { RefreshIcon } from 'src/assets/icons/RefreshIcon';

interface PropsType {
    fileName: string;
}

export const FileUploadingV2 = observer(({ fileName }: PropsType) => {
    return (
        <div className='flex items-center justify-center h-20 border-2 border-dashed border-gray-300 mt-2'>
            <RefreshIcon className='mr-2 animate-spin h-5 w-5' />
            <div className='flex flex-col'>
                <span className='text-sm leading-none mb-1'>{fileName}</span>
                <span className='text-xs leading-none text-gray-400'>Uploading...</span>
            </div>
        </div>
    );
});
